
        require('./index.scss');
        'use strict';

var $ = window.$;
var right = $('.right');
var left = $('.left');

var _module = {
    init: function init() {
        if (right[0] && left[0]) {
            var rightPreImg = right.find('img').attr('src');
            var leftPreImg = left.find('img').attr('src');
            var rightImg = right.attr('data-img');
            var leftImg = left.attr('data-img');
            right.bind('mouseenter', function () {
                right.find('img').attr('src', rightImg);
            });
            right.bind('mouseleave', function () {
                right.find('img').attr('src', rightPreImg);
            });
            left.bind('mouseenter', function () {
                left.find('img').attr('src', leftImg);
            });
            left.bind('mouseleave', function () {
                left.find('img').attr('src', leftPreImg);
            });
            $(window).scroll(function () {
                if ($(window).scrollTop() > 0) {
                    right.css('top', '0px');
                    right.css('right', '36px');
                    left.css('top', '0px');
                } else {
                    right.css('top', '35px');
                    right.css('right', '0px');
                    left.css('top', '35px');
                }
            });
            left.find('span').click(function (e) {
                e.preventDefault();
                right.remove();
                left.remove();
            });
            right.find('span').click(function (e) {
                e.preventDefault();
                left.remove();
                right.remove();
            });
            this.hover();
        }
    },
    hover: function hover() {
        if (navigator.userAgent.indexOf('Trident') == -1) {
            var eventIn = new window.Event('mouseover');
            var eventOut = new window.Event('mouseout');
            $(document).ready(function () {
                right[0].dispatchEvent(eventIn);
                left[0].dispatchEvent(eventIn);
            });
            setTimeout(function () {
                right[0].dispatchEvent(eventOut);
                left[0].dispatchEvent(eventOut);
            }, 5000);
        }
    }
};
setTimeout(_module.init(), 1000);;
    


// WEBPACK FOOTER //
// ./src/module/home-detail/flanks-ad/index.js